// @flow
import React, { PureComponent } from 'react';
import { ffrName } from 'utils/ffrNameUtils';
import type { StructureType } from 'types/Result';

type Props = StructureType;

class RencontreHeaderStructure extends PureComponent<Props> {
  render() {
    const { nom, embleme, isRegroupement, structures } = this.props;
    const isMax = nom.length > 30;

    const structuresName = (structures && structures.map((structure) => ffrName(structure.nom))) || [];

    return (
      <div>
        <span className="banner__scoreboard__image">
          <img src={embleme} alt={`logo rugby ${nom}`}/>
        </span>
        <h3 title={nom} className="mt-2 ft-center ft-h4">
          {`${ffrName(nom.slice(0,30))}${isMax ? '...' : ''}`}
        </h3>
        {isRegroupement && (
          <button
            title={structuresName.join(', \r\n')}
            className="teams-counter"
          >
            {(structures && structures.length) || 2}
            &nbsp;équipes
          </button>
        )}
      </div>
    );
  }
}

export default RencontreHeaderStructure;
